import debounce from 'lodash/debounce';

const screens = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
    '3xl': '1900px',
};

export default {
    data() {
        return {
            screens,
            debounced: null,
            isSm: false,
            isMd: false,
            isLg: false,
            isXl: false,
            is2xl: true,
            is3xl: false,
            debounceTime: 50,
        };
    },
    mounted() {
        if (process.client && window) {
            this.calculateBreakpoints();

            this.debounced = debounce(this.calculateBreakpoints, this.debounceTime);
            window.addEventListener('resize', this.debounced);
        }
    },
    beforeDestroy() {
        if (process.client && window && this.debounced) {
            window.removeEventListener('resize', this.debounced);
        }
    },
    methods: {
        isScreenMinWidth(breakpointWidth) {
            return matchMedia && matchMedia('(min-width: ' + parseInt(breakpointWidth) + 'px)').matches;
        },
        isScreenMaxWidth(width) {
            return this.requireWindow(() => {
                const widthInt = parseInt(width);

                return window.innerWidth <= widthInt;
            });
        },
        requireWindow(cb) {
            if (process.client && window) {
                return cb();
            }

            return false;
        },
        calculateBreakpoints() {
            if (process.client && window) {
                this.isSm = this.isScreenMinWidth(this.screens.sm);
                this.isMd = this.isScreenMinWidth(this.screens.md);
                this.isLg = this.isScreenMinWidth(this.screens.lg);
                this.isXl = this.isScreenMinWidth(this.screens.xl);
                this.is2xl = this.isScreenMinWidth(this.screens['2xl']);
                this.is3xl = this.isScreenMinWidth(this.screens['3xl']);
            }
        },
    },
};
